import { API_URL_AWARD } from "@constants/env";
import useApiCall from "@hooks/Shared/useApiCall";
import { IAward } from "@interfaces/award";

const useGetAward = (uuid: string) =>
  useApiCall<IAward>({
    url: API_URL_AWARD + uuid,
  });

export default useGetAward;
